import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

// Máscara CPF
function maskCPF(v) {
  return v.replace(/\D/g,'').slice(0,11)
    .replace(/(\d{3})(\d)/,'$1.$2')
    .replace(/(\d{3})\.(\d{3})(\d)/,'$1.$2.$3')
    .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/,'$1.$2.$3-$4');
}

// ── STEP INDICATOR ────────────────────────────────────────────────────────────
function Steps({ current }) {
  const steps = ['Verificar identidade', 'Informar e-mail', 'E-mail enviado'];
  return (
    <div style={{ display:'flex', alignItems:'center', gap:0, marginBottom:32 }}>
      {steps.map((label, i) => {
        const idx = i + 1;
        const active  = idx === current;
        const done    = idx < current;
        return (
          <div key={idx} style={{ display:'flex', alignItems:'center', flex: i < steps.length - 1 ? 1 : 'none' }}>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4 }}>
              <div style={{
                width:30, height:30, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
                fontSize:13, fontWeight:700,
                background: done ? '#2ECC71' : active ? '#000080' : '#e5e5e5',
                color: (done || active) ? '#fff' : '#999',
                transition:'all .3s'
              }}>
                {done ? '✓' : idx}
              </div>
              <span style={{ fontSize:10, color: active ? '#000080' : done ? '#2ECC71' : '#aaa',
                fontWeight: active ? 700 : 500, whiteSpace:'nowrap' }}>{label}</span>
            </div>
            {i < steps.length - 1 && (
              <div style={{ flex:1, height:2, background: done ? '#2ECC71' : '#e5e5e5',
                margin:'0 8px', marginBottom:16, transition:'background .3s' }} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  // Step 1
  const [form1, setForm1] = useState({ login:'', cpf:'', data_nascimento:'' });

  // Step 2
  const [userData, setUserData] = useState(null); // { userId, nome, hasEmail, emailMasked }
  const [email, setEmail]       = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  // ── STEP 1: verificar identidade ───────────────────────────────────────────
  const handleVerify = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/api/auth/forgot-password/verify`, form1);
      setUserData(data);
      setEmail(''); // limpa e-mail
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao verificar dados');
    } finally { setLoading(false); }
  };

  // ── STEP 2: enviar e-mail ──────────────────────────────────────────────────
  const handleSend = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/api/auth/forgot-password/send`, {
        userId: userData.userId,
        email: email.trim().toLowerCase(),
      });
      setSuccessMsg(data.message);
      setStep(3);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao enviar e-mail');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth:480 }}>

        {/* Logo */}
        <div className="auth-logo">
          <img src="/favicon.ico" alt="Logo" style={{ width:52, height:52, objectFit:'contain', marginBottom:4 }} />
          <h1 className="auth-title">POLITICS SYSTEM</h1>
          <p className="auth-sub">Recuperação de Senha</p>
        </div>

        <Steps current={step} />

        {/* ── STEP 1 ── */}
        {step === 1 && (
          <form onSubmit={handleVerify} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div style={{ background:'#f0f4ff', border:'1px solid #c8d4f0', borderRadius:8,
              padding:'12px 16px', fontSize:13, color:'#000080', lineHeight:1.6 }}>
              <strong>🔐 Verificação de identidade</strong><br />
              Informe seus dados cadastrais para confirmar sua identidade.
            </div>

            <div className="field-group">
              <label className="r-label">LOGIN DO SISTEMA</label>
              <input className="r-input" value={form1.login} required
                onChange={e => setForm1({...form1, login: e.target.value})}
                placeholder="Seu login de acesso" autoComplete="username" />
            </div>

            <div className="field-group">
              <label className="r-label">CPF</label>
              <input className="r-input" value={form1.cpf} required
                onChange={e => setForm1({...form1, cpf: maskCPF(e.target.value)})}
                placeholder="000.000.000-00" inputMode="numeric" maxLength={14} />
            </div>

            <div className="field-group">
              <label className="r-label">DATA DE NASCIMENTO</label>
              <input className="r-input" type="date" value={form1.data_nascimento} required
                onChange={e => setForm1({...form1, data_nascimento: e.target.value})}
                max={new Date().toISOString().split('T')[0]} />
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <button className="btn" disabled={loading}
              style={{ padding:'13px', fontSize:14, letterSpacing:1, marginTop:4 }}>
              {loading ? 'VERIFICANDO...' : 'VERIFICAR IDENTIDADE →'}
            </button>

            <div style={{ textAlign:'center' }}>
              <Link to="/login" style={{ fontSize:13, color:'#000080', textDecoration:'none', fontWeight:600 }}>
                ← Voltar para o login
              </Link>
            </div>
          </form>
        )}

        {/* ── STEP 2 ── */}
        {step === 2 && userData && (
          <form onSubmit={handleSend} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div style={{ background:'#f0fff4', border:'1px solid #a8e6c0', borderRadius:8,
              padding:'12px 16px', fontSize:13, color:'#1a7a40', lineHeight:1.6 }}>
              <strong>✅ Identidade confirmada!</strong><br />
              Olá, <strong>{userData.nome}</strong>. Informe o e-mail para receber o link de redefinição.
            </div>

            <div className="field-group">
              <label className="r-label">E-MAIL PARA RECUPERAÇÃO</label>
              {userData.hasEmail && (
                <p style={{ fontSize:12, color:'#777', margin:'4px 0 8px' }}>
                  E-mail cadastrado: <strong>{userData.emailMasked}</strong><br />
                  Você pode confirmar o mesmo ou informar um novo.
                </p>
              )}
              <input className="r-input" type="email" value={email} required
                onChange={e => setEmail(e.target.value)}
                placeholder="seu@email.com" autoComplete="email" />
              <p style={{ fontSize:11, color:'#999', marginTop:6 }}>
                O link de redefinição será enviado para este endereço. Válido por <strong>1 hora</strong>.
              </p>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <button className="btn" disabled={loading}
              style={{ padding:'13px', fontSize:14, letterSpacing:1, marginTop:4 }}>
              {loading ? 'ENVIANDO...' : 'ENVIAR LINK DE RECUPERAÇÃO →'}
            </button>

            <button type="button" onClick={() => { setStep(1); setError(''); }}
              style={{ background:'none', border:'none', cursor:'pointer', fontSize:13,
                color:'#000080', fontWeight:600, padding:4 }}>
              ← Voltar
            </button>
          </form>
        )}

        {/* ── STEP 3: SUCESSO ── */}
        {step === 3 && (
          <div style={{ display:'flex', flexDirection:'column', gap:20, textAlign:'center' }}>
            <div style={{ fontSize:56, lineHeight:1 }}>📧</div>
            <h3 style={{ fontSize:18, fontWeight:800, color:'#111', margin:0 }}>
              E-mail enviado!
            </h3>
            <p style={{ fontSize:14, color:'#555', lineHeight:1.7, margin:0 }}>
              {successMsg || 'Verifique sua caixa de entrada e clique no link para criar uma nova senha.'}
            </p>
            <div style={{ background:'#f0f4ff', border:'1px solid #c8d4f0', borderRadius:8,
              padding:'12px 16px', fontSize:13, color:'#000080', lineHeight:1.6, textAlign:'left' }}>
              <strong>⏱ Atenção:</strong><br />
              • O link expira em <strong>1 hora</strong><br />
              • Verifique também a pasta de <strong>spam/lixo eletrônico</strong><br />
              • Cada link só pode ser utilizado <strong>uma vez</strong>
            </div>
            <button className="btn" onClick={() => navigate('/login')}
              style={{ padding:'13px', fontSize:14, letterSpacing:1 }}>
              VOLTAR PARA O LOGIN
            </button>
          </div>
        )}

        {/* Rodapé */}
        {step !== 3 && (
          <div style={{ marginTop:24, borderTop:'1px solid #e0e0e0', paddingTop:14, textAlign:'center' }}>
            <p style={{ fontSize:11, color:'#aaa', margin:0 }}>Todos os direitos reservados PoliticSYS©</p>
          </div>
        )}
      </div>
    </div>
  );
}
